import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProfileHeader from './components/ProfileHeader';
import PurchaseHistory from './components/PurchaseHistory';
import SpecialOffers from './components/SpecialOffers';

export default function Profile() {
  const navigate = useNavigate();

  // Check if user is logged in
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (!isLoggedIn) {
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900">My Account</h1>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-logout-box-line w-5 h-5 flex items-center justify-center"></i>
              Logout
            </button>
          </div>
          <ProfileHeader />
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <PurchaseHistory />
            </div>
            <div>
              <SpecialOffers />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
